import { Injectable } from "@angular/core";
import { BaseService } from "./base-service";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs/operators";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
    providedIn: 'root',
})
export class SpecificityService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/clientspecificity`;

    constructor(public http: HttpClient,
        protected coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected router: Router) {
        super(router, coreData, snackBare);
    }

    getSpecificityForClient(clientCode: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${clientCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getSpecificityForClient')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response 
            }));
    }
}